var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheaterLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_76671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 6.76221C2.66699 3.76393 5.05481 1.33334 8.00033 1.33334C10.9458 1.33334 13.3337 3.76393 13.3337 6.76221C13.3337 9.73699 11.6314 13.2083 8.97561 14.4496C8.3565 14.739 7.64415 14.739 7.02504 14.4496C4.36921 13.2083 2.66699 9.73699 2.66699 6.76221Z",
    stroke: "#646464"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6.66666,
    r: 2,
    stroke: "#646464"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_76671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheaterLocation);
export default __webpack_public_path__ + "static/media/TheaterLocation.96ef9a62ae3dc8d867fc0ea42b943334.svg";
export { ForwardRef as ReactComponent };